<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
    >
        <path
            d="M10.8079 1.39844H3.1919C2.20221 1.39844 1.3999 2.20074 1.3999 3.19044V10.8064C1.3999 11.7962 2.20221 12.5984 3.1919 12.5984H10.8079C11.7976 12.5984 12.5999 11.7962 12.5999 10.8064V3.19044C12.5999 2.20074 11.7976 1.39844 10.8079 1.39844Z"
            stroke="currentColor"
            stroke-width="1.2096"
            stroke-miterlimit="3.99393"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
